import React from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import { TP } from 'constants/index';

import { useTranslation } from 'src/i18n';

import classes from './CalendarLegends.module.scss';

const SHOW_TYPE = {
  PAST: {
    value: `${TP}.PAST_SHOWS`,
    name: 'past',
  },
  UPCOMING: {
    value: `${TP}.UPCOMING_SHOWS`,
    name: 'upcoming',
  },
  WEEKEND: {
    value: `${TP}.WEEKEND_SHOWS`,
    name: 'weekend',
  },
  CANCELLED: {
    value: `${TP}.CANCELLED_SHOWS`,
    name: 'cancelled',
  },
};

const CalendarLegends = () => {
  const { t } = useTranslation('NS_APP_GLOBALS');

  const firstRow = [SHOW_TYPE.PAST, SHOW_TYPE.UPCOMING];
  const secondRow = [SHOW_TYPE.WEEKEND, SHOW_TYPE.CANCELLED];

  const renderRow = rowItems => (
    <div className={classes.showTypes__row}>
      {rowItems.map(type => (
        <div className={classes.showTypes__type} key={type.value}>
          <span
            className={classnames(classes.showTypes__type_box, {
              [classes[`box_${type.name}`]]: !![classes[`box_${type.name}`]],
            })}
          ></span>
          <Typography size={11} className={classes.showType}>
            {t(type.value)}
          </Typography>
        </div>
      ))}
    </div>
  );

  return (
    <div className={classes.showTypes}>
      {renderRow(firstRow)}
      {renderRow(secondRow)}
    </div>
  );
};

export default CalendarLegends;
